import { Icon } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box, Flex, Text } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';

interface AccountChecklistTaskType {
  iconName: 'checklistMarkCompleted' | 'checklistMarkToDo';
}

interface IncompleteTaskProps {
  eventName: string;
  url?: string;
  title: string;
  subText?: string;
}

const Wrapper: React.FC<React.PropsWithChildren<AccountChecklistTaskType>> = ({ iconName, children }) => {
  const isCompletedIcon = iconName === 'checklistMarkCompleted';
  const status = isCompletedIcon ? 'complete' : 'incomplete';
  const checklistIcon = isCompletedIcon ? (
    <Icon name="CheckmarkCircleFilled" size="small" color="icon.success" />
  ) : (
    <Icon name="CheckmarkCircle" size="small" color="icon.weakest" />
  );

  return (
    <Flex role="listitem" justifyContent="flex-start" alignItems="flex-start" py="3">
      <Box aria-label={status} mr="4">
        {checklistIcon}
      </Box>
      {children}
    </Flex>
  );
};

const IncompleteTask: React.FC<React.PropsWithChildren<IncompleteTaskProps>> = ({
  eventName,
  url = '',
  title,
  subText,
}) => (
  <Wrapper iconName="checklistMarkToDo">
    <Flex flexDirection="column">
      <SambaAutoLink
        to={url}
        title={title}
        onClick={() => trackClick({ name: eventName, module: 'CheckingAccountSetupChecklist' })}
      >
        {title}
      </SambaAutoLink>
      {subText && (
        <Text color="bmtGrey50" fontSize="1">
          {subText}
        </Text>
      )}
    </Flex>
  </Wrapper>
);

const AccountChecklistTask: React.FC<React.PropsWithChildren<AccountChecklistTaskType>> = ({ iconName, children }) => (
  <Wrapper iconName={iconName}>
    <Text as="p" m="0" pb="2" color="bmtGrey90">
      {children}
    </Text>
  </Wrapper>
);

export { IncompleteTask, AccountChecklistTask };
